import { IUser } from '@/pages/Users/users.types.ts'
import useEntity from '@/recoil/useEntity/useEntity.ts'
import usersAtom from '@/pages/Users/users.atom.ts'
import usersApi from '@/pages/Users/users.api.ts'

const useUser = (id: IUser['id']) => {
  const { loading, entity } = useEntity({
    atom: usersAtom,
    itemFetcher: usersApi.getOne,
    entityId: id,
  })

  return { loading, user: entity }
}

export default useUser
